export default __webpack_public_path__ + "static/game-right-c5233f22d98dae4061bbf224bfddffff.svg";